"use strict";

$(document).ready(function () {

    // Отключение пуша SendPulse если его уже показали
    if (getCookie('sendPulse') == null) {
        var timerId = setInterval(function () {
            checkSendPulse(timerId);
        }, 500);
    }

    if ($('.alert').length) {
        setTimeout(function () {
            $('.alert').fadeOut();
        }, 5000);
    }

    // Проверка наличия счётчика ВК. Задержка нужна, потому, что счётчик не сразу
    // инициализируется и появляется переменная window.VK
    //setTimeout(function () {
    //    if (!window.VK) {
    //        window.VK = {};
    //    }
    //    if (!VK.Goal) {
    //        VK.Goal = function (targetName) {
    //            console.log('Счётчик ВК не подключился. targetName: ' + targetName);
    //        }
    //    }
    //}, 1000);

    // Табы на странице калькулятора
    $(document).on("click", ".calc-tabs__btn", function (e) {
        e.preventDefault();
        var $tabs = $(this).closest(".calc-tabs");
        $tabs.find(".calc-tabs__btn").removeClass("active");
        $tabs.find(".calc-tabs__item").removeClass("active");
        $(this).addClass("active");
        $tabs.find(".calc-tabs__item").eq($(this).index()).addClass("active");
    });

    // Диаграмма займа
    function calcChart(val1, val2) {
        if ($('.js-calc-chart').length) {
            $('.js-calc-chart').empty();
            $('.js-calc-chart').radialPieChart('init', {
                'fill': 14,
                'background': 'transparent',
                'lines': 0,
                'font-size': 0,
                'data': [
                    { 'color': '#F4F4F4', 'perc': val1 },
                    { 'color': '#82DA9D', 'perc': val2 }
                ]
            });
        }
    }
    // Показать диаграмму на мобилке
    $(document).on('click', '.js-toggle-calc-chart', function (e) {
        e.preventDefault();
        $('.calc-result__chart').toggleClass('active');
    });

    // При клике на кнопку "Получить деньги" включаем счётчик ЯндексМетрики
    $(document).on('click', '.loanerContact', function (e) {
        e.preventDefault();

        //VK.Goal('initiate_checkout');

        // Вызываем Метрику через прослойку
        ymInterlayer('getmoney', 'link', $(this).attr('href'));
    });

    if ($('.getInTime').length) {
        var date = new Date();
        date.setMinutes(date.getMinutes() + 30);
        $('.getInTime').html(date.getHours() + ':' + ('0' + date.getMinutes()).slice(-2));
    }

    // Slick slider init
    if ($('.js-slider').length) {
        var slider = $('.js-slider'),
            slider_dots = $('#sliderDots');

        slider.slick({
            slidesToShow: 2,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        infinite: true,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });

        slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            setTimeout(function () {
                slider_dots.find('.is-current').removeClass('is-current');
                slider_dots.find('.js-slick-dot:nth-child(' + (nextSlide + 1) + ')').addClass('is-current');
            }, 20);
        });

        slider_dots.find('.js-slick-dot').on('click', function () {
            slider_dots.find('.is-current').removeClass('is-current');
            $(this).addClass('is-current');
            slider.slick('slickGoTo', $(this).index());
        });
    }
    Number.prototype.format = function (n, x, s, c) {
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = this.toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };
    $(document).on('click', '.js-toggle-payment-table', function (e) {
        e.preventDefault();
        $('.js-payment-table table').addClass('active');
        $(this).closest('.calc-block__table-link').css('display', 'none');
    });
    $(document).on('click', '.js-calc-result-link', function (e) {
        e.preventDefault();
        var loanAmount = $('.js-calc-loanAmount').val(),
            rate = $('.js-calc-rate').val(),
            rateUnits = $('.js-calc-rate').closest('.calc-field').find('select').val(),
            term = $('.js-calc-term').val(),
            termUnits = $('.js-calc-term').closest('.calc-field').find('select').val(),
            delayPenalty = $('.js-calc-delayPenalty').val(),
            delayPenaltyUnits = $('.js-calc-delayPenalty').closest('.calc-field').find('select').val();
        var link = 'https://credit.monster/calc?loanAmount=' + loanAmount + '&rate=' + rate + '&rateUnits=' + rateUnits + '&term=' + term + '&termUnits=' + termUnits + '&delayPenalty=' + delayPenalty + '&delayPenaltyUnits=' + delayPenaltyUnits;
        var temp = $('<input>');
        $('body').append(temp);
        temp.val(link).select();
        document.execCommand('copy');
        temp.remove();
        alert('Ссылка скопирована в буфер обмена');
    });
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };
    // input[type=range] func
    $('.js-inputrange').each(function () {
        var $this = $(this), $value = $this.val();
        $this.rangeslider({
            polyfill: false,
            onInit: function () {
                this.output = (this.$element.closest('.js-range').find('.js-range-amount')).html(SeparateThreeDigits(this.$element.val()));
            },
            onSlide: function (position, value) {
                this.output.html(SeparateThreeDigits(value));
                $('.money_back').html(SeparateThreeDigits(value));
                document.cookie = 'amount=' + value;

                if ($('.s-fields__amount').length) {
                    $('.s-fields__amount span:first').html(SeparateThreeDigits($('.js-inputrange').val()));
                }
                if ($('.success__subtitle').length) {
                    $('.success__subtitle span:first').html(SeparateThreeDigits($('.js-inputrange').val()));
                }
                if ($this.closest('.calc-fields').length) {
                    if ($value != value) {
                        $value = value;
                        fillCalcData();
                    }
                }
            },
        });
    });
    function getCalcUrlParams() {
        var loanAmount = getUrlParameter('loanAmount');
        var rate = getUrlParameter('rate');
        var rateUnits = getUrlParameter('rateUnits');
        var term = getUrlParameter('term');
        var termUnits = getUrlParameter('termUnits');
        var delayPenalty = getUrlParameter('delayPenalty');
        var delayPenaltyUnits = getUrlParameter('delayPenaltyUnits');
        if (loanAmount) {
            $('.js-calc-loanAmount').val(loanAmount);
        }
        if (rate) {
            $('.js-calc-rate').val(rate);
        }
        if (rateUnits) {
            $('.js-calc-rate').closest('.calc-field').find('select option[value=' + rateUnits + ']').prop('selected', true);
        }
        if (term) {
            $('.js-calc-term').val(term);
        }
        if (termUnits) {
            $('.js-calc-term').closest('.calc-field').find('select option[value=' + termUnits + ']').prop('selected', true);
        }
        if (delayPenalty) {
            $('.js-calc-delayPenalty').val(delayPenalty);
        }
        if (delayPenalty) {
            $('.js-calc-delayPenalty').val(delayPenalty);
        }
        if (delayPenaltyUnits) {
            $('.js-calc-delayPenalty').closest('.calc-field').find('select option[value=' + delayPenaltyUnits + ']').prop('selected', true);
        }
        $('input[type="range"]').rangeslider('update', true);
    }
    function fillCalcData() {
        var loanAmount = $('.js-calc-loanAmount').val(), rate = $('.js-calc-rate').val(), rateUnits = $('.js-calc-rate').closest('.calc-field').find('select').val(), term = $('.js-calc-term').val(), termUnits = $('.js-calc-term').closest('.calc-field').find('select').val(), delayPenalty = $('.js-calc-delayPenalty').val(), delayPenaltyUnits = $('.js-calc-delayPenalty').closest('.calc-field').find('select').val();
        $.ajax({
            url: '/calculator',
            method: 'POST',
            data: { loanAmount: loanAmount, rate: rate, rateUnits: rateUnits, term: term, termUnits: termUnits, delayPenalty: delayPenalty, delayPenaltyUnits: delayPenaltyUnits },
            dataType: 'json',
            success: function (data) {
                $('.js-calc-result-monthlyPayment').text(data.monthlyPayment.format(0, 0, ' '));
                $('.js-calc-result-generalPayment').text(data.generalPayment.format(0, 0, ' '));
                $('.js-calc-result-loanAmount').text(data.loanAmount.format(0, 0, ' '));
                $('.js-calc-result-loanCost').text(data.loanCost.format(0, 0, ' '));
                $('.js-calc-result-rate').text(data.rate);
                $('.js-calc-result-penaltyAmount').text(data.penaltyAmount.format(0, 0, ' '));
                $('.js-payment-table').empty();
                $('.js-payment-table').html(data.paymentSchedule);
                if ($('.js-payment-table tr').length > 6) {
                    $('.calc-block__table-link').addClass('active');
                    $('.calc-block__table-link').removeAttr('style');
                }
                calcChart((data.loanCost / (data.loanCost + data.loanAmount)) * 100, (data.loanAmount / (data.loanCost + data.loanAmount)) * 100);
            },
            error: function (msg) {
                console.log(msg)
            }
        });
    }
    $('.calc-fields').find('select').on('change', function () {
        fillCalcData();
    });
    if ($('.calc-blocks').length) {
        getCalcUrlParams();
        fillCalcData();
    }

    // Показываем слайдер на внутрянке
    $(document).on('click', '.s-fields__change', function (e) {
        $('.slider-popup').hide().removeClass('d-none').fadeIn();
    });
    // Скрываем при клике вне слайдера
    $(document).mouseup(function (e) {
        var slider = $('.slider-popup'),
            success = $('.success__popup');
        if (slider.has(e.target).length === 0) {
            slider.fadeOut();
        }
        if (success.has(e.target).length === 0) {
            success.fadeOut();
        }
    });
    // При подтверждении изменения суммы в слайдере внутрянки
    $(document).on('click', '.confirm_amount', function (e) {
        $('.slider-popup').fadeOut();
        //$('.s-fields__amount span:first').html(SeparateThreeDigits($('.js-inputrange').val()));
    });

    // Подтверждение ухода со страницы на страницах с формами
    if (($('form[name="contact"]').length != 0) || ($('form[name="userdata"]').length != 0)
        || ($('form[name="passportdata"]').length != 0) || ($('form[name="address"]').length != 0)) {
        set_onbeforeunload = function () {
            return true;
        };

        $(document).on('input', ':input', function () {
            window.onbeforeunload = set_onbeforeunload;
        });
    }

    // Кнопка "У меня нет карты"
    $(document).on('click', '.success__nocard, .success__nocard_mobile', function (e) {
        $('.success__popup').hide().removeClass('d-none').fadeIn();
    });
    // Кнопка "Активировать" для продолжения ввода карты
    $(document).on('click', '.btn_activate', function (e) {
        $('.success__popup').fadeOut();
    });

    // Dropdown func
    $(document).on('click', '.js-drop-link', function (e) {
        e.preventDefault();
        var ths = $(this),
            wrap = ths.closest('.js-drop-wrap'),
            block = wrap.find('.js-drop-block');

        block.fadeToggle('100');
        ths.toggleClass('is-active');
    });

    // Scrollbar init
    if ($('.js-scrollbar').length) {
        $('.js-scrollbar').scrollbar();
    }

    // Checkbox stylization
    $('label input[type=checkbox]').each(function () {
        if ($(this).is(':checked')) {
            $(this).closest('label').addClass('is-checked');
        }
        $(this).on('change', function () {
            $(this).closest('label').toggleClass('is-checked');
        });
    });

    // Radio stylization
    $('label input[type=radio]').each(function () {
        if ($(this).is(':checked')) $(this).closest('label').addClass('is-checked');
        $(this).on('change', function () {
            // Если до этого была ошибка - снимаем для всех radio класс "is-error"
            $('.for-radio').removeClass('is-error');
            var nm = $(this).attr('name');
            $('label input[name=' + nm + ']').each(function () {
                if ($(this).is(':checked')) {
                    $(this).closest('label').addClass('is-checked');
                } else {
                    $(this).closest('label').removeClass('is-checked');
                }
            });
        });
    });

    // Datepicker init
    if ($('#datepicker').length && !mobile) {

        if ($('#datepicker').val() == '') {
            var datePickerValue = $('#datepicker').attr('placeholder');
        } else {
            var datePickerValue = $('#datepicker').val();
        }

        var startDate = new Date(datePickerValue.replace(/(\d+).(\d+).(\d+)/, '$3/$2/$1'));

        $('#datepicker').datepicker({
            dateFormat: 'dd.mm.yyyy',
            autoClose: true,
            startDate: startDate,
            onShow: function (inst, animationCompleted) {
                $('#datepicker').closest('.js-for-datepicker').addClass('is-active');
            },
            onHide: function (inst, animationCompleted) {
                $('#datepicker').closest('.js-for-datepicker').removeClass('is-active');
            },
            onSelect: function (formattedDate, date, inst) {
                fillingСheck($('#datepicker'));
                if ($('input[name="familiya"]').length != 0) {
                    moveFocus(1, 0);
                }
                if ($('input[name="seriya_pasporta"]').length != 0) {
                    moveFocus(2, 4);
                }
            }
        });
    }

    // Если галочка "Согласен с условиями оферты" нажата - убираем возможный красный контур
    $(document).on('click', 'input[name="offer"]', function (e) {
        if ($('input[name="offer"]').is(':checked')) {
            $('.for-checkbox_big_is-error').removeClass('for-checkbox_big_is-error').addClass('for-checkbox_big');
        }
    });
    $(document).on('click', 'input[name="registration"]', function (e) {
        if ($('input[name="registration"]').is(':checked')) {
            $('.registration').hide().removeClass('d-none').slideDown();
        } else {
            $('.registration').slideUp();
            $('input[name="fakticheskij_region"]').val('');
            $('input[name="fakticheskij_gorod"]').val('');
            $('input[name="fakticheskij_ulica"]').val('');
            $('input[name="fakticheskij_dom"]').val('');
            $('input[name="fakticheskij_kvartira"]').val('');
        }
    });
    // Если галочка "Нет отчества" нажата - отключаем инпут
    $(document).on('click', 'input[name="patronymic"]', function (e) {
        var patronymic = $('input[name="otchestvo"]');
        if ($('input[name="patronymic"]').is(':checked')) {
            patronymic.prop('disabled', true);
            patronymic.val('');
            patronymic.removeClass('is-valid');
            patronymic.removeClass('is-error');
        } else {
            patronymic.prop('disabled', false);
        }
    });

    // Перемещаем фокус для выпадаек, если они не установлены в дефолтное значение
    $('select[name="svedeniya_o_rabote"]').on('change', function () {
        var val = $('option:selected', this).val();
        if (val != '0') {
            moveFocus(1, 1);
        }
    });
    $('select[name="kogda_brali_zajm"]').on('change', function () {
        var val = $('option:selected', this).val();
        if (val != '0') {
            moveFocus(1, 2);
        }
    });

    // Bankcard func
    var bankcard = $('#bankcard'),
        bankcard_number = $('#bankcardNumber'),
        bankcard_monthyear = $('#bankcardMonthyear'),
        bankcard_name = $('#bankcardName'),
        bankcard_cvv = $('#bankcardCvv');

    $('input[name="nomer_karty"]').on('focus', function () {
        if (bankcard.hasClass('is-flipped')) {
            bankcard.removeClass('is-flipped');
        }
        bankcard_number.addClass('is-active');
    }).on('blur', function () {
        bankcard_number.removeClass('is-active');
    });

    $('input[name="imya_vladelca"]').on('focus', function () {
        if (bankcard.hasClass('is-flipped')) {
            bankcard.removeClass('is-flipped');
        }
        bankcard_name.addClass('is-active');
    }).on('blur', function () {
        bankcard_name.removeClass('is-active');
    });

    $('input[name="mesyac_god"]').on('focus', function () {
        if (bankcard.hasClass('is-flipped')) {
            bankcard.removeClass('is-flipped');
        }
        bankcard_monthyear.addClass('is-active');
    }).on('blur', function () {
        bankcard_monthyear.removeClass('is-active');
    });

    $('input[name="cvv"]').on('focus', function () {
        if (!bankcard.hasClass('is-flipped')) {
            bankcard.addClass('is-flipped');
        }
        bankcard_cvv.addClass('is-active');
    }).on('blur', function () {
        bankcard_cvv.removeClass('is-active');
    });

    if ($('.checkdata__title').length) {

        var delay = 5000,
            count = 0;
        var timerId = setTimeout(function request() {

            count++;
            // Если прошла минута - редиректим принудительно
            if (count > 12) {
                location.href = redirectUrl;
            }

            $.ajax({
                method: 'POST',
                url: checkUrl,
                data: {
                    user: user
                },
                dataType: 'json'
            }).done(function (data) {
                if (data.ready) {
                    location.href = redirectUrl;
                }
            });

            timerId = setTimeout(request, delay);

        }, delay);

        // На случай, если нужно отключить ФССП (код выше закомментировать)
        //var timerId = setTimeout(function request() {
        //    location.href = redirectUrl;
        //}, 15000);
    }

    $('.cat__another').on('click', function () {
        var another = $('.another');
        another.animate({
            opacity: 0
        },
            0,
            function () {
                another.removeClass('d-none');
                another.addClass('cat s-catalog__cat');
                another.animate({ opacity: 1 }, 1000);
            });

        $('.cat__another').addClass('d-none');
    });
    $(document).on('click', '.btn_catalog', function (e) {
        e.preventDefault();
        var href = $(this).attr('href'),
            needOpenForcibly = true;
        //ym(55669441, 'reachGoal', 'offer_click', {}, function() {
        // Отключаем функцию, которая выполняется через 2 секунды,
        // чтобы окно не открылось два раза
        needOpenForcibly = false;
        catalogClick(href);
        //});

        // Если по каким-то причинам код выше не отработал
        //setTimeout(function() {
        //    if (needOpenForcibly) {
        //        catalogClick(href);
        //    }
        //}, 2000);
    });

    /*
     * Страница ввода карты
     */
    //if ($('.success__title').length) {
        //// Создаём форму
        //var form = document.createElement('form');
        ////form.action = 'https://fpay.uniteller.ru/v1/pay';
        //form.action = 'https://wpay.uniteller.ru/pay/';
        //form.method = 'post';
        //form.target = 'pay_iframe';
        //
        //// Передаём параметры
        //form.appendChild(addInput('Shop_IDP', shopIdp));
        //form.appendChild(addInput('Order_IDP', orderIdp));
        //form.appendChild(addInput('Subtotal_P', subtotalP));
        //form.appendChild(addInput('Signature', signature));
        ////form.appendChild(addInput('Receipt', receipt));
        ////form.appendChild(addInput('ReceiptSignature', receiptSignature));
        //form.appendChild(addInput('URL_RETURN_OK', urlOk));
        //form.appendChild(addInput('URL_RETURN_NO', urlNo));
        //form.appendChild(addInput('Currency', 'RUB'));
        //form.appendChild(addInput('IsRecurrentStart', 1));
        //form.appendChild(addInput('Email', email));
        //
        //document.body.appendChild(form);
        //
        //form.submit();
    //}

    // Если оплата на странице /payment прошла успешно
    //if (typeof checkDataUrl !== 'undefined') {
    //    //VK.Goal('add_payment_info');
    //    //ymInterlayer('card', 'parent', checkDataUrl); это перенесено на саму страницу тут можно оставить закомментированным. работать будет.
    //}
});

function catalogClick(href) {
    var catCounter = $('.cat-counter').html();

    if (typeof catCounter != 'undefined') {
        catCounter++;
        $('.cat-counter').html(catCounter);
    }
    if (catCounter == 3) {
        $('.s-catalog__fixed').html('Внимательно заполните три выбранных заявки и ждите решения!');
    }

    var offerWindow = window.open();
    offerWindow.opener = null;
    offerWindow.location = href;
}

function SeparateThreeDigits(summ) {
    return summ.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1&#8198;");
}

// Функция отрисовки правильности/неправильности ввода данных в поле
// elem  - селектор (строка) или объект (объект)
// state - true/false - будем выделять красным (ошибка) или зелёным (заполнено верно)
// isNotEmpty - будет ли считаться ошибкой значение по умолчанию
function fillingСheck(elem, state = true, isNotEmpty = false, emptyDefaultValue = '') {
    // К нам пришёл селектор или объект
    if (elem.jquery !== 'undefined') {
        var obj = $(elem);
    } else {
        var obj = elem;
    }
    // Если значение равно дефолтному и не нужно делать проверку на то что дефолтное значение это ошибка
    if ((obj.val() == emptyDefaultValue) && (isNotEmpty === false)) {
        obj.removeClass('is-valid');
        obj.removeClass('is-error');
    } else {
        if (state === true) {
            obj.addClass('is-valid');
            obj.removeClass('is-error');
        } else {
            obj.removeClass('is-valid');
            obj.addClass('is-error');
        }
    }
}

// Функция передачи фокуса на элемент
function moveFocus(listNum, elem) {

    var list = {
        // Контактная информация
        0: [
            'input[name="emejl"]',
            'button[type="submit"]'
        ],
        // Пользовательские данные
        1: [
            'select[name="svedeniya_o_rabote"]',
            'select[name="kogda_brali_zajm"]',
            'button[type="submit"]'
        ],
        // Паспортные данные
        2: [
            'input[name="nomer_pasporta"]',
            'input[name="kod_podrazdeleniya"]',
            'input[name="kem_vydan"]',
            '#datepicker',
            'input[name="mesto_rozhdeniya"]',
            'button[type="submit"]'
        ],
        // Отписка
        3: [
            'input[name="god_rozhdeniya"]',
            'button[type="submit"]'
        ],
        // Личный кабинет
        4: [
            'input[name="kod"]',
            'button[type="submit"]'
        ]
    };

    var $focusedElem = $(list[listNum][elem]);

    // Если следующий элемент уже корректно заполнен
    if ($focusedElem.hasClass('is-valid') == true) {
        elem++;
        moveFocus(listNum, elem);
    } else {

        setTimeout(function () {
            $focusedElem.trigger('focus');
        }, 100);
    }
}

function addInput(name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    return input;
}

function showAlert(message) {
    // Удаляем возможное уведомление (если было ранее)
    $('#alertNotification').remove();
    var alert = document.createElement('div');
    alert.className = 'container alert alert-danger d-none';
    alert.setAttribute('id', 'alertNotification');
    alert.innerHTML = message;
    document.body.appendChild(alert);
    $('.alert').hide().removeClass('d-none').fadeIn();

    setTimeout(function () {
        $('.alert').fadeOut();
    }, 5000);
}

// Если SendPulse показан - в дальнейшем отключить
function checkSendPulse(timerId) {
    if ($('.sendpulse-prompt').length) {
        setCookie('sendPulse', 1, 1);
        clearInterval(timerId);
    }
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
}

// Функция-прослойка между Метрикой
function ymInterlayer(targetName, action, value) {

    //ym(55669441, 'reachGoal', targetName, {}, function() {
    if (action == 'link') {
        window.location = value;
    }
    if (action == 'parent') {
        window.parent.location = value;
    }
    if (action == 'submit') {
        $(value).off('submit').submit();
    }
    //});

    // Если по каким-то причинам код выше не отработал
    setTimeout(function () {
        if (action == 'link') {
            window.location = value;
        }
        if (action == 'parent') {
            window.parent.location = value;
        }
        if (action == 'submit') {
            $(value).off('submit').submit();
        }
    }, 2000);
}
